module.exports = __webpack_public_path__ + "da12cd7e9e480d19466635d8a7f8505c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/warning-icon.png
// module id = 2871
// module chunks = 0